import { useTranslation } from "react-i18next";
import { convertApiHeaderToReactTableHeader } from "src/components/Common/UI/DndTable/UtilFunctions";
import { useMemo } from "react";
import { useGetBillingViaPhoneLineNumber } from "../api/getBillingViaPhoneLineNumber";

// All your logic is here
export const usePhoneLineBillingReport = ({phoneNumber}: usePhoneLineBillingReportProps) => {
  const getBillingViaPhoneLineNumberQuery = useGetBillingViaPhoneLineNumber({phoneNumber: phoneNumber});
  const { t } = useTranslation();

  const loadingDone = [getBillingViaPhoneLineNumberQuery].every(({ isFetching }) => !isFetching);

  const errorData = [getBillingViaPhoneLineNumberQuery].some(({ isError }) => isError);

  const dataTypes = [
    { id: 0, apiType: "Default", frontType: "", frontDisplayFormat: "" },
    { id: 1, apiType: "Integer", frontType: "number", frontDisplayFormat: "" },
    { id: 2, apiType: "Double", frontType: "number", frontDisplayFormat: "" },
    { id: 3, apiType: "Date", frontType: "date", frontDisplayFormat: "YYYY-MM-DD HH:mm:ss", sourceDisplayFormat: "YYYY-MM-DDTHH:mm:ss" },
    { id: 4, apiType: "String", frontType: "string", frontDisplayFormat: "" },
    { id: 5, apiType: "yyyyMMdd", frontType: "date", frontDisplayFormat: "YYYY-MM-DD", sourceDisplayFormat: "YYYYMMDD" },
    { id: 6, apiType: "Boolean", frontType: "boolean", frontDisplayFormat: "" },
    { id: 7, apiType: "IntegerTime", frontType: "date", frontDisplayFormat: "HH:mm:ss", sourceDisplayFormat: "seconds" },
    { id: 8, apiType: "yyyyMM", frontType: "date", frontDisplayFormat: "MMM YYYY", sourceDisplayFormat: "YYYYMM" },
    { id: 9, apiType: "Number", frontType: "number", frontDisplayFormat: "", defaultEmptyValue: 0 }
  ];

  const data = getBillingViaPhoneLineNumberQuery.data ? getBillingViaPhoneLineNumberQuery.data : [];
  const totalRecords = getBillingViaPhoneLineNumberQuery.data ? getBillingViaPhoneLineNumberQuery.data.length : 0;

  const columnData = [
    {
      columnName: "month",
      columnDisplayName: "Μήνας",
      visible: true,
      columnOrder: 1,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "year",
      columnDisplayName: "Έτος",
      visible: true,
      columnOrder: 2,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "provider",
      columnDisplayName: "Πάροχος",
      visible: true,
      columnOrder: 3,
      isDraggable: false,
      columnDataType: "String",
    },
    {
      columnName: "monthlyFees",
      columnDisplayName: "Μηνιαία τέλη",
      visible: true,
      columnOrder: 4,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "OnceFees",
      columnDisplayName: "Εφάπαξ τέλη",
      visible: true,
      columnOrder: 5,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "usageFees",
      columnDisplayName: "Τέλη χρήσης",
      visible: true,
      columnOrder: 6,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "totalFees",
      columnDisplayName: "Σύνολα",
      visible: true,
      columnOrder: 7,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "actualFees",
      columnDisplayName: "Συν/α + ΦΠΑ",
      visible: true,
      columnOrder: 8,
      isDraggable: false,
      columnDataType: "Number",
    },
    {
      columnName: "oteFpa",
      columnDisplayName: "Φ.Π.Α.",
      visible: true,
      columnOrder: 9,
      isDraggable: false,
      columnDataType: "String",
    },
    
  ]

  const columns = useMemo(() => {
    return convertApiHeaderToReactTableHeader(
      columnData ,
      dataTypes
    );
  }, []);


  return {
    data,
    columns,
    loadingDone,
    t,
    totalRecords,
    errorData
  };
};

interface usePhoneLineBillingReportProps {
  phoneNumber: string;
}